import React, { useState, useEffect } from 'react';
import axios from 'axios';
import DaySquare from './DaySquare';
import './Calendar.css'; // Importe o arquivo CSS para estilização
import { Cake, Groups2, Celebration, Place } from '@mui/icons-material';

const Calendar = () => {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [eventData, setEventData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [aniversarios, setAniversarios] = useState([]);
  const token = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";

  // Função para buscar dados da API
  const fetchEventData = async (year, month) => {
    setLoading(true);
      // Substitua pela URL real da sua API.
      // A API deve retornar um objeto onde as chaves são os dias do mês (ex: {"10": "Valor em destaque", "25": "Outro valor"})
      const dados = {
        "mes": month,
        "ano": year
      };
//console.log(dados);
      axios
      .post(
        process.env.REACT_APP_API_URL + 
        '/routes.php?metodo=obtemAgendasResumo', dados,
        {
          headers: {
            "X-Access-Token": token,
            "Content-Type": "application/json; charset=utf-8",
          }
        }
      )
      .then((response) => {
        //console.log(response.data);
        setEventData(response.data);
        setError(null);
        setLoading(false);
      })
      .catch((error) => {
        setError('Falha ao carregar os dados dos eventos.');
        setEventData({});
        setLoading(false);
      });
    }

  useEffect(() => {
    fetchEventData(currentDate.getFullYear(), currentDate.getMonth() + 1);
    fetchAniversarios(currentDate.getMonth() + 1);
  }, [currentDate]);

  const fetchAniversarios = (month) => {
    setLoading(true);
    const dados = {
      "mes": month
    };
    axios
      .post(
        process.env.REACT_APP_API_URL +
        '/routes.php?metodo=obtemAniversariosMes', dados,
        {
          headers: {
            "X-Access-Token": token,
            "Content-Type": "application/json; charset=utf-8",
          }
        }
      )
      .then((response) => {
        setAniversarios(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  }

  //console.log(eventData);

  // Lógica para gerar os dias do mês
  const renderDays = () => {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const firstDayIndex = new Date(year, month, 1).getDay(); // 0 (Dom) a 6 (Sáb)

    const days = [];
    // Adiciona dias vazios para preencher a primeira semana
    for (let i = 0; i < firstDayIndex; i++) {
      days.push(<div key={`empty-${i}`} className="day empty"></div>);
    }
    // Adiciona os dias do mês com os dados
    for (let i = 1; i <= daysInMonth; i++) {
      const dateString = `${year}-${String(month + 1).padStart(2, '0')}-${String(i).padStart(2, '0')}`;
      const highlightValue = !eventData.message && eventData.find(u => parseInt(u.day) === i)?.ageDescricao || '';
      //console.log(eventData[i]);
      days.push(
        <DaySquare 
          key={i} 
          day={i} 
          highlightValue={highlightValue} 
          date={dateString} 
          OnClick={() => alert(`Evento no dia ${dateString}: ${highlightValue || 'Nenhum evento'}`)}
        />
      );
    }
    return days;
  };

  const goToPreviousMonth = () => {
    setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1));
  };

  const goToNextMonth = () => {
    setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1));
  };

  if (loading) return <p className='text-align-center'>Carregando calendário...</p>;
  if (error) return <p>{error}</p>;

const barraMesAno = currentDate.toLocaleString('pt-BR', { month: 'long', year: 'numeric' });

  return (
    <div className="calendar-container mb4">
      <div className="calendar-header">
        <button className="buttonGridPadrao fs9" onClick={goToPreviousMonth}>Anterior</button>
        <span className='calendar-title fs9 text-align-center'>
          <b>{barraMesAno.toUpperCase().replace('DE ', '')}</b>
        </span>
        <button className="buttonGridPadrao fs9" onClick={goToNextMonth}>Próximo</button>
      </div>
      <div className="weekdays">
        {['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'].map(day => (
          <div key={day} className="weekday">{day}</div>
        ))}
      </div>
      <div className="calendar-grid">
        {renderDays()}
      </div>
      {/* LISTAGEM DE EVENTOS DO MÊS */}
      <div className='d-flex w100 flex-column flex-md-row justify-content-center align-items-start gap-4'>
        <div className='boxCenter'>
          <Groups2 style={{ width: 50, height: 50 }} />
          <p className='pt2'><h2>Listagem dos eventos do mês.</h2></p>
          <div>
            {eventData.length > 0 && !eventData.message ? (
              <div>
                <ul className='list pt1'>
                  {eventData.map(event => (
                    <li className='pt1' key={event.id}>
                      <b>{event.day}/{currentDate.getMonth() + 1}:</b> {event.ageDescricao}
                    </li>
                  ))}
                </ul>
              </div>
            ) : (
              <p className='text-align-center mt2'>Nenhum evento cadastrado para este mês.</p>
            )}  
          </div>
        </div>
      </div>
      {/* LISTAGEM DE ANIVERSARIANTES DO MÊS */}
      <div className='d-flex w100 flex-column flex-md-row justify-content-center align-items-start gap-4'>
        <div className='boxCenter'>
          <Cake style={{ width: 50, height: 50 }} />
          <p className='pt2'><h2>Aniversariantes do mês.</h2></p>
          {aniversarios.length > 0 ? (
            <div>
              <ul className='list pt1'>
                {aniversarios.map(aniversariante => (
                  <li className='pt1' key={aniversariante.IdPessoa}>
                    <b>{aniversariante.dia}/{aniversariante.mes}:</b> {aniversariante.pesApelido} ({aniversariante.idade})
                  </li>
                ))}
              </ul>
            </div>
          ) : (
            <p className='text-align-center mt2'>Nenhum aniversariante este mês.</p>
          )} 
        </div>   
      </div>
    </div>
  );
};


export default Calendar;